import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-display text-xl">{title}</h2>
      <div className="mt-2 space-y-3 text-[#5a4f46]">{children}</div>
    </section>
  );
}

export default function LegalNotice() {
  return (
    <main data-testid="legal-notice-page" className="px-5 sm:px-8 py-10 max-w-3xl mx-auto">
      <Link to="/" data-testid="legal-notice-back-link" className="inline-flex items-center gap-1.5 hover:underline"><ArrowLeft size={16} /> Volver</Link>
      <h1 className="font-display text-4xl sm:text-5xl mt-8">Aviso legal</h1>
      <p className="text-sm text-[#7a6c5e] mt-3">Última actualización: 28 de octubre de 2026</p>

      <div className="mt-10 space-y-8">
        <Section title="1. Titular">
          <p><strong>Titular:</strong> Sara Álvarez Navarro</p>
          <p><strong>NIF:</strong> 47659933T</p>
          <p><strong>Domicilio:</strong> Cova Fumada 5, 08870 Sitges, Barcelona</p>
          <p><strong>Correo electrónico:</strong> <a href="mailto:endosmundos.digital@gmail.com" className="underline font-semibold">endosmundos.digital@gmail.com</a></p>
          <p><strong>Web:</strong> <a href="https://endosmundos.com" className="underline">https://endosmundos.com</a></p>
        </Section>

        <Section title="2. Objeto">
          <p>En Dos Mundos ofrece recursos y talleres educativos online relacionados con la comunicación familiar, la crianza y las relaciones de pareja.</p>
          <p>El taller tiene carácter educativo y no constituye un servicio de diagnóstico, psicoterapia ni atención psicológica sanitaria.</p>
        </Section>

        <Section title="3. Condiciones de uso">
          <p>La persona usuaria se compromete a utilizar el sitio web de forma lícita y responsable, sin perjudicar su funcionamiento ni vulnerar los derechos de terceros.</p>
          <p>La contratación del taller se rige también por las <Link to="/condiciones-de-compra" className="underline font-semibold">Condiciones de contratación, desistimiento y devoluciones</Link>.</p>
        </Section>

        <Section title="4. Propiedad intelectual">
          <p>Los contenidos, materiales, diseños y recursos de la web están protegidos por la normativa de propiedad intelectual. No podrán reproducirse, distribuirse ni comercializarse sin autorización, salvo en los casos permitidos legalmente.</p>
        </Section>

        <Section title="5. Responsabilidad">
          <p>En Dos Mundos procurará mantener el sitio web actualizado y operativo, sin garantizar la ausencia absoluta de errores o interrupciones técnicas.</p>
          <p>Este aviso no limita los derechos irrenunciables reconocidos a las personas consumidoras.</p>
        </Section>

        <Section title="6. Protección de datos">
          <p>El tratamiento de datos personales se regula en la <Link to="/politica-de-privacidad" className="underline font-semibold">Política de privacidad</Link> publicada en esta web.</p>
        </Section>

        <Section title="7. Legislación aplicable">
          <p>Se aplicará la legislación española y europea que corresponda. En caso de contratación con consumidores, se respetarán las normas imperativas de protección de consumidores y usuarios.</p>
        </Section>
      </div>
    </main>
  );
}